import React from 'react';
import { ColumnProps, TaskProps } from '../../types/boardTypes';
import styled from '@emotion/styled';
import MoreButton from '../MoreButton';
import PlusButton from '../PlusButton';
import { TaskCard } from './TaskCard';
import { Draggable, Droppable } from 'react-beautiful-dnd';

type ColumnComponentProps = {
  column: ColumnProps;
  tasks: TaskProps[];
  columnIndex: number;
};

const Wrapper = styled.div`
  width: 272px;
  min-width: 272px;
  flex-shrink: 0;
  display: block;
  height: 100%;
  max-height:100%;
  margin: 0 8px;
`;

const WhiteContainer = styled.div`
  background-color: ${({ theme }) => theme?.colors.backgroundColor};
  border-radius: 16px;
  width: 272px;
  min-width: 272px;
  flex-shrink: 1;
  max-height:100%;
  display: flex;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 8px;
  border-radius: 16px;
  min-width: 272px;
  // opacity 0.05
  background-color: ${({ theme }) => theme.colors.primaryColor + '0D'};
  justify-content: space-between;
  max-height:100%;
  position: relative;
  white-space: normal;
  vertical-align: top;
`;

const TaskList = styled.div`
  min-height:8px;
  overflow-y: auto;
  padding: 0 8px;
  flex: 1 0;
  display:flex;
  flex-direction: column;
  height:100%;
  flex-shrink: 0;
`;

const Column = ({ column, tasks, columnIndex }: ColumnComponentProps) => {
  return (
    <Draggable draggableId={column.id} index={columnIndex}>
      {(providedColumn) => {
        if (
          typeof (
            providedColumn.draggableProps.onTransitionEnd
          ) === 'function'
        ) {
          window?.requestAnimationFrame(() =>
            providedColumn.draggableProps.onTransitionEnd({
              propertyName: 'transform',
              elapsedTime: 0,
              pseudoElement: '',
              nativeEvent: undefined,
              currentTarget: undefined,
              target: undefined,
              bubbles: false,
              cancelable: false,
              defaultPrevented: false,
              eventPhase: 0,
              isTrusted: false,
              preventDefault: function (): void {
                throw new Error('Function not implemented.');
              },
              isDefaultPrevented: function (): boolean {
                throw new Error('Function not implemented.');
              },
              stopPropagation: function (): void {
                throw new Error('Function not implemented.');
              },
              isPropagationStopped: function (): boolean {
                throw new Error('Function not implemented.');
              },
              persist: function (): void {
                throw new Error('Function not implemented.');
              },
              timeStamp: 0,
              type: '',
            }),
          );
        }
        return (
          <Wrapper ref={providedColumn.innerRef} {...providedColumn.draggableProps}>
            <WhiteContainer {...providedColumn.dragHandleProps}>
              <Container>
                <Droppable droppableId={column.id} type='task'>
                  {(provided) => (
                    <>
                      <div className='planner-column-top'>
                        <span className='planner-title'>{column.title}</span>
                        <MoreButton />
                      </div>
                      <TaskList className='u-fancy-scrollbar' ref={provided.innerRef} {...provided.droppableProps}>
                        {tasks.map((task, index) => (
                          <TaskCard key={task.id} index={index} {...task} />
                        ))}
                        {provided.placeholder}
                      </TaskList>
                      <div className='planner-column-add-wrapper'>
                        <PlusButton />
                        <span className='planner-text'>Додати задачу</span>
                      </div>
                    </>
                  )}
                </Droppable>
              </Container>
            </WhiteContainer>
          </Wrapper>
        );
      }}
    </Draggable>
  );
};

export { Column };
